"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = exports.LinkStyles = exports.linkVisitedStyles = exports.linkFocusOnlyStyles = exports.linkFocusHoverStyles = exports.linkDefaultStyles = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Tokens = __importStar(require("../../styles/tokens"));
const tokens_1 = require("../../styles/tokens");
const defaultColour = (0, styled_components_1.css) `
    color: ${(props) => props.$isDarkTheme
    ? tokens_1.COLOURS.greyscale.white
    : tokens_1.COLOURS.primary.blue[100]};
`;
const defaultBorder = (0, styled_components_1.css) `
    border: none;
    border-radius: ${Tokens.BORDERS.radius};
`;
/** Padding is so that curved borders above don't clip the content of the link text */
const defaultSpacing = (0, styled_components_1.css) `
    padding: 0 ${Tokens.SIZES[0.25]};
`;
const hoverFocusColour = (0, styled_components_1.css) `
    color: ${(props) => props.$isDarkTheme
    ? tokens_1.COLOURS.primary.green[130]
    : tokens_1.COLOURS.primary.blue[130]};
`;
const hoverFocusBackgroundColour = (0, styled_components_1.css) `
    background-color: ${(props) => props.$isDarkTheme
    ? tokens_1.COLOURS.primary.green[5]
    : tokens_1.COLOURS.primary.blue[25]};
`;
const hoverFocusIconFill = (0, styled_components_1.css) `
    path {
        fill: ${(props) => props.$isDarkTheme
    ? tokens_1.COLOURS.primary.green[130]
    : tokens_1.COLOURS.primary.blue[130]};
    }
`;
const focusStyling = (0, styled_components_1.css) `
    outline: none;
    box-shadow: 0 0 0 2px ${tokens_1.COLOURS.greyscale.white},
        0 0 0 4px ${tokens_1.COLOURS.primary.blue[100]};
`;
exports.linkDefaultStyles = (0, styled_components_1.css) `
    ${defaultColour}
    ${defaultBorder}
    ${defaultSpacing}
    text-decoration: underline;
`;
exports.linkFocusHoverStyles = (0, styled_components_1.css) `
    ${hoverFocusColour}
    ${hoverFocusBackgroundColour}
    ${hoverFocusIconFill}
    text-decoration: none;
`;
exports.linkFocusOnlyStyles = (0, styled_components_1.css) `
    ${focusStyling}
`;
exports.linkVisitedStyles = (0, styled_components_1.css) `
    ${defaultColour}
`;
/**
 * @deprecated Use `Ds.Link` instead
 */
exports.LinkStyles = (0, styled_components_1.css) `
    font-family: Roboto, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    width: max-content;
    height: max-content;
    ${exports.linkDefaultStyles}

    /* All elements expect first child (ie: gap between icon and text) */
    > *:not(:first-child) {
        /* same as margin-left with rtl support */
        margin-inline-start: ${Tokens.SIZES[0.5]};
    }

    &:visited {
        ${exports.linkVisitedStyles}
    }

    &:hover,
    &:focus {
        ${exports.linkFocusHoverStyles}
    }

    /* Ensure focus styling defined here always overrides global styles using more specific selector when using this */
    &:focus&:focus {
        ${exports.linkFocusOnlyStyles}
    }
`;
/**
 * @deprecated Use `Ds.Link` instead
 */
exports.StyledLink = styled_components_1.default.a `
    ${exports.LinkStyles}
`;
//# sourceMappingURL=Link.styles.js.map